// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  loginStatus: {
    data: null,
  },
  getVideoListStatus: { data: null },
  createVideoStatus: { data: null },
  editVideoStatus: { data: null },
  deleteVideoStatus: { data: null },
};
